import { Box, Typography } from "@mui/material";
import { Plans } from "schemas/payments";

import PlanCard from "../PlanCard";
import styles from "./styles";

interface Props {
  canSubscribe: boolean;
  ctaLabel: string;
  subNote: string;
  onSubscribe: (plan: Plans) => void;
}

const PLAN_CARDS = [
  {
    plan: Plans.PRO,
    planName: "Pro Plan",
    blurb: "For creators who pitch often",
    price: "34",
    payTwo: "$68",
    saved: "$34",
    features: [
      "Access 600k+ brand contacts",
      "Advanced brand filters",
      "Reply likelihood scores",
      "Follow-up assistant",
    ],
  },
  {
    plan: Plans.VA,
    planName: "AI Virtual Assistant",
    blurb: "Hands-off pitching for busy creators",
    price: "72",
    payTwo: "$144",
    saved: "$72",
    featuresIntro: "Everything in Pro, plus:",
    features: [
      "300 automated pitches per month",
      "Exclusive filters & brand pay data",
    ],
  },
];

const B2GoPlans = ({ canSubscribe, ctaLabel, subNote, onSubscribe }: Props) => {
  return (
    <Box sx={styles.panel}>
      <Typography sx={styles.heading}>Choose your plan</Typography>
      <Box sx={styles.grid}>
        {PLAN_CARDS.map((card) => (
          <PlanCard
            key={card.plan}
            planName={card.planName}
            blurb={card.blurb}
            price={card.price}
            payTwo={card.payTwo}
            saved={card.saved}
            featuresIntro={card.featuresIntro}
            features={card.features}
            canSubscribe={canSubscribe}
            ctaLabel={ctaLabel}
            subNote={subNote}
            onSubscribe={() => onSubscribe(card.plan)}
          />
        ))}
      </Box>
    </Box>
  );
};

export default B2GoPlans;
